<template>
  <div>
    <div class="block__content">
      <h2>{{ $t('title') }}</h2>
      <br/>

      <div v-if="!isInit && !cryptoaddressAvailable">
        <profile-update-required-crypto-notice
          :cryptoaddress-available="cryptoaddressAvailable"></profile-update-required-crypto-notice>
      </div>

      <div v-if="isInit">
        <div class="text-center loader-wrapper">
          <circle-loader></circle-loader>
        </div>
      </div>

      <template v-if="cryptoaddressAvailable">
        <payout-hint-panel :warning="true">
          {{ $t('usdt.alert_line_1') }}
          <br/>
          <i18n path="usdt.alert_line_min" tag="span">
            <template slot="min">5 USDT (ERC20, TRC20)</template>
          </i18n>
          <br/>
          {{ $t('usdt.alert_line_2') }}
          <br/>
          {{ $t('usdt.alert_line_3') }}
          <br/>
          <i18n path="usdt.alert_line_4" tag="span">
            <template slot="min">10</template>
            <template slot="amount">10%</template>
            <template slot="currency">USD</template>
          </i18n>
        </payout-hint-panel>
      </template>


    </div>
    <div v-if="!isInit && cryptoaddressAvailable" class="block__content no-pd">

      <ul class="tarnsfer_form">
        <li>

          <div class="form-step">
            <h2>{{ $t('title_2') }}</h2>
            <form role="form">

              <div class="form-group" style=""><span
                class="control-label required">{{ $t('beneficiary') }}</span>

                <div style="width: 370px;">
                  <PrimeDropdownAccounts :disabled="formDisabled" :accounts="accounts"
                                         v-model="model.values.account"
                                         @input="onSelectDestAccount">
                  </PrimeDropdownAccounts>
                  <!--                  <dropdown-accounts :placeholder="$t('select_account')" :selection-object="true"
                                                       :accounts="accounts"
                                                       :value="options.destAccount"
                                                       @input="onSelectDestAccount">
                                    </dropdown-accounts>-->
                </div>
              </div>
            </form>
          </div>
        </li>

        <li v-if="visibleWallets.length > 0">
          <div class="form-step">
            <h2>{{ $t('requisites') }}</h2>
            <form role="form">

              <div class="form-group" style=""><span
                class="control-label required">{{ $t('usdt_address') }}</span>


                <div>
                  <dropdown-crypto-addresses :addresses="visibleWallets"
                                             style="width: 370px"
                                             v-model="model.selectedAddress"></dropdown-crypto-addresses>

                </div>


              </div>

              <div class="form-group" v-if="!showHidden && hasHidden" style=""><span
                class="control-label"></span>
                <div class="form-control-space">
                  <a href="#" class="link-hovered"
                     @click.prevent="showHidden = true">{{ $t('show_hidden_addresses') }}</a>
                </div>

              </div>

              <template v-if="selectedAddress">
                <div class="form-group" style=""><span
                  class="control-label">{{ $t('address') }}</span>
                  <span class="form-control">{{ selectedAddress.address }}</span>
                </div>

                <div class="form-group form-group-horizontal my-hint-block">
                  <span class="control-label"></span>
                  <div class="form-control-space">
                    <payout-hint-panel>
                      <template v-if="selectedAddress.system === 'Trc20'">
                        <i18n path="selected_network" tag="span">
                          <template slot="network">Tron (TRC20)</template>
                        </i18n>
                      </template>
                      <template v-if="selectedAddress.system === 'Erc20'">
                        <i18n path="selected_network" tag="span">
                          <template slot="network">Ethereum (ERC20)</template>
                        </i18n>
                      </template>
                    </payout-hint-panel>
                  </div>
                </div>


                <template
                  v-if="selectedAddress.autoConvert && selectedAddress.autoConvertAccountNumber">
                  <div class="form-group form-group-horizontal my-hint-block">
                    <span class="control-label"></span>
                    <div class="form-control-space">
                      <payout-hint-panel :heading="$t('Автоконвертация')" :warning="true">
                        <i18n path="autoconvertHint" class="autoconvert-warning" tag="div">
                          <template #account>
                            <span class="autoconvert-warning--account">{{
                                selectedAddress.autoConvertAccountNumber
                              }}</span>
                          </template>
                          <template #fromcur><strong>{{selectedAddress.publicCurrency}}</strong></template>
                          <template #tocur><strong>{{getAccountNumberCurrency(selectedAddress.autoConvertAccountNumber)}}</strong></template>
                        </i18n>
                      </payout-hint-panel>
                    </div>
                  </div>
                </template>
              </template>


              <div class="text-center" v-if="selectedAddress">

                <br/>
                <br/>
                <div style="width:300px; margin: 0 auto;">
                  <qrcode-styling :source-data="selectedAddress.address"
                                  :qrcode-styling-config="qrcodeConfig"></qrcode-styling>
                </div>

              </div>
            </form>
          </div>
        </li>
      </ul>
    </div>
  </div>
</template>

<script lang="ts">
import Vue from "vue";
import {Component, Prop, Watch} from "vue-property-decorator";
import QrcodeStyling from "@/components/other/QrcodeStyling.vue";
import ProfileUpdateRequiredCryptoNotice
  from "@/views/pages/finance/accounts/crypto/notice/ProfileUpdateRequiredCryptoNotice.vue";
import CircleLoader from "@/components/loaders/CircleLoader.vue";
import DropdownCryptoAddresses from "@/components/forms/dropdown/DropdownCryptoAddresses.vue";
import PayoutHintPanel from "@/components/forms/payout/PayoutHintPanel.vue";
import {DepositUsdtTransferModel} from "@/views/pages/finance/deposit/usdt/deposit-usdt";
import PrimeDropdownAccounts from "@/components/forms/dropdown/PrimeDropdownAccounts.vue";
import {getAccountNumberCurrency} from "webapp/src/models/core/currency";

@Component({
  name: "DepositUsdtTransferPage",
  methods: {getAccountNumberCurrency},
  components: {
    PrimeDropdownAccounts,
    PayoutHintPanel,
    DropdownCryptoAddresses,
    CircleLoader, ProfileUpdateRequiredCryptoNotice, QrcodeStyling
  }
})
export default class DepositUsdtTransferPage extends Vue {
  model = new DepositUsdtTransferModel()

  showHidden = true

  get isInit() {
    return !this.model.initStatus.isLoaded
  }

  onSelectDestAccount() {
    this.model.autoselectAddress(this.showHidden)
  }

  get cryptoaddressAvailable() {
    return this.model.initStatus.isLoaded && this.model.options.avail
  }

  get formDisabled() {
    return this.isInit
  }

  mounted() {
    this.reloadModel()
  }

  get hasHidden() {
    return this.model.addresses.filter(a => a.hidden).length > 0
  }

  reloadModel() {
    this.model.loadModel().catch(err => {
      this.model.initStatus.loadStart()
      setTimeout(() => {
        this.reloadModel()
      }, 3000)
    })
  }

  get accounts() {
    return this.model.accounts
  }

  get selectedAddress() {
    return this.model.selectedAddress
  }

  // @Watch('selectedAddress')
  // onSelectedAddressChange() {
  //   //this.model.onAccountChange(this.showHidden)
  // }

  get visibleWallets() {
    const currency = this.model.selectedAccount?.cryptoCurrency;
    return this.model.getVisibleAddresses(this.showHidden)
      .filter(address => !currency || (address.currency == currency))
  }

  get qrcodeConfig() {
    return {
      width: 250,
      height: 250,
      type: "svg",
      margin: 0,
      //data: "https://www.facebook.com/",
      // image: 'data:image/svg+xml;base64,' + CapLogoImage.logoWorking, //"https://upload.wikimedia.org/wikipedia/commons/5/51/Facebook_f_logo_%282019%29.svg",
      dotsOptions: {
        color: "#627f23", //93bb36
        type: "square"
      },
      backgroundOptions: {
        color: "#ffffff",
      },
      cornersSquareOptions: {
        "type": "extra-rounded",
        //"color": "#000000"
      },
      imageOptions: {
        hideBackgroundDots: true,
        crossOrigin: "anonymous",
        imageSize: 0.5,
        margin: 0
      },
      qrOptions: {typeNumber: "10", mode: "Byte", errorCorrectionLevel: "H"}
    }
  }
}
</script>

<style scoped lang="less">
.loader-wrapper {
  display: flex;
  justify-content: center;
  margin: 3em 0 1em 0;
}

.qrcode-wrapper {
  width: 300px;
  margin: 0 auto;
}

.autoconvert-warning {
  .autoconvert-warning--account {
    font-weight: bold;
  }
}
</style>


<i18n>
{
  "en": {
    "title": "Deposit funds to Capitalist account by USDT Tether (ERC20 or TRC20) transfer",
    "usdt": {
      "alert_line_1": "In order to deposit funds, please make payment to USDT Tether (ERC20 or TRC20) address below.",
      "alert_line_min": "Minimum deposit amount is {min}. Smaller amount transactions will not be deposited on your Capitalist account.",
      "alert_line_2": "After receiving six network confirmations, the funds will be credited to your account.",
      "alert_line_3": "Please note: ONLY direct USDT Tether payments allowed.",
      "alert_line_4": "Commission for a search of incorrectly specified transfer will be {amount} of the payment amount (minimum {min} {currency})."
    },
    "title_2": "Beneficiary account",
    "beneficiary": "Beneficiary",
    "select_account": "Select account",
    "requisites": "Requisites",
    "usdt_address": "USDT Tether (ERC20 or TRC20) address",
    "show_hidden_addresses": "Show hidden addresses",
    "address": "Address",
    "selected_network": "Selected address is belongs to network {network}.",
    "autoconvertHint": "Attention! You have selected an address with enabled autoconversion. When you deposit to this address, the funds will be automatically converted ({fromcur} / {tocur}) to the account {account} at the current exchange rate.",
    "Автоконвертация": "Autoconversion"
  },
  "ru": {
    "autoconvertHint": "Внимание! Вы выбрали для пополнения адрес со включенной автоконвертацией. При пополнении указанного адреса произойдет автоматическая конвертация средств ({fromcur} / {tocur}) на счет {account} по текущему курсу.",
    "selected_network": "Выбран адрес из сети {network}.",
    "address": "Адрес",
    "show_hidden_addresses": "Показать скрытые адреса",
    "usdt_address": "Адрес USDT Tether (ERC20 или TRC20)",
    "requisites": "Реквизиты",
    "select_account": "Выберите аккаунт",
    "beneficiary": "Получатель",
    "title_2": "Счет для пополнения",
    "title": "Пополнение счета Capitalist.net с помощью USDT Tether (ERC20 или TRC20) перевода",
    "usdt": {
      "alert_line_1": "Для пополнения счета с помощью USDT Tether (ERC20 или TRC20) необходимо перевести средства со своего кошелька на указанный ниже USDT адрес.",
      "alert_line_min": "Минимальная сумма пополнения {min}. В случае отправки перевода на сумму менее {min} средства не будут зачислены на счет Capitalist.",
      "alert_line_2": "После получения шести подтверждений сети средства будут зачислены на ваш счет.",
      "alert_line_3": "Обращаем Ваше внимание, на данные реквизиты принимаются ТОЛЬКО прямые платежи с кошельков USDT Tether.",
      "alert_line_4": "В случае некорректно указанных данных комиссия за поиск составит {amount} от суммы платежа (но не менее {min} {currency})."
    }
  }
}
</i18n>
